<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title" *ngIf="!loadingPhoto">{{photo.Title}}</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>
  <div class="ttmodal__body">
      <div class="center" *ngIf="loadingPhoto">
          <mat-spinner></mat-spinner>
      </div>
      <div *ngIf="!loadingPhoto">
          <div  class="photo-container"><img  class="photo-container__photo"  [src]="getImage(photo.ImageData)" /></div>
          <div style="margin-top: 16px;">{{photo.Comment}}</div>
      </div>
  </div>
  <div class="ttmodal__footer" *ngIf="userCanDeletePhoto">
      <a class="button" (click)="deletePhoto()" [class.loading]="photoIsDeleting"><span class="material-icons button__icon">delete</span><span class="button__text">Delete</span></a>
  </div>
</div>
